import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Dashboard from "../components/MerchantDashboard";
import StarRating from "../components/StarRating";
import CustomHelmet from "../components/CustomHelmet";
import axios from "axios";
import Fade from "react-reveal/Fade";
import { Alert, Spinner } from "react-bootstrap";

const url = "https://www.hubsquares.com/php_files/processRateUs.php/";
const RateUs = (props) => {
  const [rating, setRating] = useState(0);
  const [spin, setSpin] = useState(false);
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [success, setSuccess] = useState(false);
  const [review, setReview] = useState("");
  async function handleSubmit(e) {
    e.preventDefault();
    if (review !== "") {
      setSpin(true);
      const formData = new FormData();
      formData.append("owner", props.user);
      formData.append("rating", rating);
      formData.append("review", review);
      await axios
        .post(url, formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          if (data.success === 1) {
            setSuccess(true);
            setErrorValue(data.msg);
            setError(false);
            setReview("");
            setSpin(false);
            setRating(0);
          } else if (data.success === 0) {
            setErrorValue(data.msg);
            setError(true);
            setSuccess(false);
            setSpin(false);
          }
        });
    } else {
      setError(true);
      setErrorValue("All fields are required");
    }
  }
  useEffect(() => {
    if (error || success) {
      setTimeout(() => {
        setError(false);
        setSuccess(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error, success]);

  return (
    <>
      <CustomHelmet page="Rate Hubsquares" />
      <Dashboard user={props.user} page="Rate Hubsquares">
        <Container className="my-3">
          <h5>
            <i className="fa fa-star" aria-hidden="true"></i>
            Rate us and write a review
          </h5>
          <div className="my-2">
            {error && (
              <Fade bottom collapse when={error}>
                <Alert variant="danger">{errorValue}</Alert>
              </Fade>
            )}
            {success && (
              <Fade bottom collapse when={success}>
                <Alert variant="success">{errorValue}</Alert>
              </Fade>
            )}
          </div>
          <hr />
          <p>Choose your rating for our service</p>
          <StarRating rating={rating} setRating={setRating} />
          <div className="">
            <i className="fa fa-star-o" aria-hidden="true"></i>
            <i className="fa fa-star-o" aria-hidden="true"></i>
            <i className="fa fa-star-o" aria-hidden="true"></i>
            <i className="fa fa-star-o" aria-hidden="true"></i>
            <i className="fa fa-star-o" aria-hidden="true"></i>
          </div>
          <form className="w-100 pt-3">
            {/* <div className="form-group">
                  <input
                    className="form-control form-control-lg"
                    type="email"
                    placeholder="Your email"
                  />
                </div> */}
            <div className="form-group">
              <textarea
                className="form-control"
                placeholder="Your Review"
                value={review}
                onChange={(e) => setReview(e.target.value)}
                rows="6"
              ></textarea>
            </div>
            <div className="form-group">
              <div className="g-recaptcha" data-sitekey="7d7d77d7"></div>
            </div>
            <button
              type="submit"
              className="btn btn-danger text-white btn-lg py-2 rad-0 addbtn"
              disabled={spin}
              onClick={(e) => handleSubmit(e)}
            >
              Submit Review
              {spin && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </form>
        </Container>
      </Dashboard>
    </>
  );
};
export default RateUs;
